// extracted by mini-css-extract-plugin
export default {"versionNumber":"k9YPvg"};